const Constants = Object.freeze({
  // ---------------------------- HOME ----------------------------
  TIME_ON: "Time on: ",
  NUM_OF_DEVICES: "Number of devices",
  MASTERS: "Masters",
  SLAVES: "Slaves",
  STATISTICS: "Statistics",

  NO_RETRIES: "No retries",

  BAUD_RATE_KBPS: "BAUD RATE (Kbps)",
  BAUD_RATE_MBPS: "BAUD RATE (Mbps)",

  CYCLE_TIME_S: "CYCLE TIME (s)",
  CYCLE_TIME_MS: "CYCLE TIME (ms)",

  WATCHDOG_MS: "WATCHDOG (ms)",

  RETRIES_LIMIT: "RETRY LIMIT",

  PROFIBUS_NETWORK_INFO: "PROFIBUS network information",

  HSA_POPUP_1: "HSA (Highest PROFIBUS Address) is the parameter that indicates the highest address where the master searches for new devices on the network using the FDL_Status protocol.",
  HSA_POPUP_2: "Also used for detecting class 2 masters or networks with more than one master.",

  // ---------------------------- Live List ----------------------------
  AVAILABILITY: "Availability",
  TAG: "Tag",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  REASON: "\nReason: ",

  EXPORT_CSV: "Export XLSX",
  CSV_HEADER: "Address,Tag,Model,Diagnostics,Retries without faults,Total retries,Faults,Availability,Watchdog,Status\n",

  // ---------------------------- Log ----------------------------
  TYPE: "Type",
  MANUFACTURER_MODEL: "Manufacturer / Model",

  // ---------------------------- Configuration page related ----------------------------
  LOGIN_CREDENTIALS_FAILURE: "An error occurred while logging in: Incorrect username or password.",
  LOGIN_GENERAL_FALIURE: "An error occurred while logging in:",

  GPG_ALERT_MESSAGE: "Only files with the .gpg extension can be sent",
  SEND_FILE_FAILURE: "An error occurred while sending the file.",
  SEND_FILES_SUCCESS: "The files were sent successfully.",
  SEND_FILE_WAITING: "Sending file.",
  SEND_FILE_WRONG_FILENAME: "Invalid name. The update file must be named: updatePB.tar.gz.gpg",
  SEND_FILE_CORRUPTED_FILE: "The update file was corrupted during upload.",
  SEND_CONFIG_SUCCESS: "The settings were sent successfully.",
  SEND_CONFIG_FAILURE: "An error occurred while sending the settings.",
  SEND_CONFIG_WAITING: "Sending settings.",
  SEND_CONFIG_WAITING_2: "Finalizing settings upload.",
  SEND_CONFIG_DONE: "Settings sent.",
  SEND_NTP_CONFIG_WAITING: "Sending NTP server settings.",
  SEND_NTP_CONFIG_DONE: "NTP server settings sent.",

  WAITING: "Please wait a moment",
  CLEAN_LOG_SUCCESS: "The log was cleared successfully.",
  CLEAN_LOG_FAILURE: "An error occurred while clearing the log.",
  CLEAN_STATISTICS_SUCCESS: "The statistics were cleared successfully.",
  CLEAN_STATISTICS_FAILURE: "An error occurred while clearing the statistics.",

  CHANGE_USERNAME_SUCCESS: "The username was changed successfully. Please log in again.",
  CHANGE_USERNAME_FAILURE: "An error occurred while changing the username: ",
  USERNAME_TOO_SHORT: "The username must contain at least one character.",
  PASSWORD_MISSMATCH: "The entered passwords do not match",
  CHANGE_PASSWORD_SUCCESS: "The password was changed successfully. Please log in again.",
  CHANGE_PASSWORD_FAILURE: "An error occurred while changing the password: ",

  VERIFY_THE_FOLLOWING_INFO: "Please check the following information:",
  INVALID_IP: "\n- The entered IP is invalid",
  INVALID_SUBMASK: "\n- The entered subnet mask is invalid",
  INVALID_GATEWAY: "\n- The entered gateway is invalid",
  INVALID_DNS: "\n- The entered DNS is invalid",
  LOOPBACK_IP: "\n- The loopback IP (127.0.0.1) cannot be used as the monitor IP",
  LOOPBACK_IP_NTP: "\n- The loopback IP (127.0.0.1) cannot be used as the NTP server IP",
  SELECT_TIMEZONE: "\n- A timezone must be selected to configure the NTP server",
  SAME_SUBNET_IP_1: "\n- The IP address of the WLAN interface cannot be on the same subnet as the ETHERNET interface.",
  SAME_SUBNET_IP_2: "\n- The IP address of the ETHERNET interface cannot be on the same subnet as the WLAN interface.",
  SUBNET_OVERLAP_WLAN: "\n- TS Monitor PROFIBUS detected an address overlap between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the WLAN with the selected IP address and mask.",
  SUBNET_OVERLAP_ETHERNET_WLAN: "\n- TS Monitor PROFIBUS detected an address overlap between the ETHERNET interface subnet and the WLAN subnet. For this reason, it is not possible to configure the ETHERNET interface with the selected IP address and mask.",
  ZERO_IP_MSG: "\n- IP 0.0.0.0 cannot be used as the TS Monitor PROFIBUS IP",
  ZERO_IP_MASK_MSG: "\n- IP 0.0.0.0 cannot be used as the network mask",
  BROADCAST_IP_MSG: "\n- The network broadcast IP cannot be used as the TS Monitor PROFIBUS IP",
  NETWORK_IP_MSG: "\n- The network IP cannot be used as the TS Monitor PROFIBUS IP",
  BROADCAST_GATEWAY_MSG: "\n- The network broadcast IP cannot be used as the gateway IP",
  NETWORK_GATEWAY_MSG: "\n- The network IP cannot be used as the gateway IP",

  EMPTY_WIFI_PWD: "\n- The Wi-Fi password cannot be empty",

  ALTER_USERNAME: "CHANGE USERNAME",
  ALTER_PASSWORD: "CHANGE PASSWORD",

  RESTART_SYSTEM: " Restart system",
  CONFIRM_RESTART_SYSTEM: "Are you sure you want to restart the system?",
  RESTART_SYSTEM_FAILURE: "An error occurred while trying to restart the system.",
  RESTART_SYSTEM_SUCCESS: "Restart request sent successfully. Please wait about 3 minutes for the system to restart completely.",

  SELECT_FILE: "Please select a file to upload",
  SELECT_GSD_FLIE: "Please select at least one GSD file to upload",
  SENDING_GSD_FILES: "Sending GSD files",

  DO_NOT_CLOSE_THIS_TAB: "Keep this tab open to follow the update.",
  UPDATING_MONITOR_FILES: "Updating files on the monitor. Please wait.",
  MONITOR_FILES_UPDATED_SUCCESSFULLY: "Files updated, preparing to restart the monitor.",
  RESTARTING_MONITOR_WAIT: "Restarting monitor, please wait a few minutes.",
  UPDATE_SUCCESS: "The update was completed successfully!",
  UPDATE_ERROR_STRING: "The following error occurred while updating the monitor: ",

  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS: "Modify at least one of the fields to update the interface settings.",
  CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN: "Modify at least one of the fields to update the WLAN settings.",

  TAG_WAS_CHANGED_SUCCESSFULLY: "The monitor tag was changed successfully.",
  TAG_CHANGE_FAILURE: "An error occurred while changing the monitor tag.",

  REMEMBER_TO_UPDATE_BROWSER_ADDRESS_TO: "\nRemember to update the browser address to: ",
  UPDATE_INTERFACE_CONFIG_SUCCESS: "The interface settings were updated successfully!",
  UPDATE_WLAN_CONFIG_SUCCESS: "The WLAN settings were updated successfully!",

  THE_FOLLOWING_FILES_COULD_NOT_BE_SENT: "An error occurred while sending the following GSD files: ",
  THE_FOLLOWING_FILES_COULD_NOT_BE_REMOVED: "An error occurred while removing the following GSD files: ",

  MANAGE: "Manage",

  TAG_CONFIG: "Network tag",

  ETHERNET: "Ethernet",
  ETHERNET_POPUP_1: "Ethernet interface configuration field.",
  ETHERNET_POPUP_2: "Used for monitoring and web access to the monitor data.",

  WLAN: "WLAN",
  WLAN_POPUP_1: "Wireless interface configuration field, when adapter is available.",
  WLAN_POPUP_2: "Used for monitoring and web access to the monitor data.",

  NTP_SERVER: "NTP Server",

  TURN_NTP_SERVER_ON: "Turn on NTP server",
  TURN_NTP_SERVER_ON_QUESTION: "Are you sure you want to turn on the NTP server? The monitor will need to be restarted for this.",

  NTP_INFO_TURNED_ON_FAILURE: "An error occurred while turning on the NTP server.",

  PROCESSING_NTP_INIT: "Starting NTP server information processing",
  PROCESSING_NTP_INFO: "Processing NTP server information.",
  PROCESSED_NTP_INFO: "NTP server information processed.",
  PROCESSING_NTP_ERROR: "An error occurred while sending information to the NTP server. Check whether the server IP address is correct. If it is, also check whether the NTP service is enabled and try again.",

  MONITOR_RESTART_SUCCESS: "The monitor was restarted successfully.",
  MONITOR_RESTART_FAILURE: "An error occurred while restarting the monitor.",

  NTP_INFO_TURNED_OFF_FAILURE: "An error occurred while turning off the NTP server.",
  NTP_INFO_FAILURE: "Failed to synchronize with the server. If the error persists, contact the NTP server administrator.",

  SEND_WLAN_CONFIG_WAITING: "Sending settings, please wait. This may take about one minute.",
  UPDATE_WLAN_CONFIG_ERROR: "Could not connect to the WLAN network. If the problem persists, try restarting the monitor or the WLAN router.",

  ALTER_MONITOR_CONFIG: "Are you sure you want to change the monitor settings?",
  IP: "IP",
  EDIT: "Edit",
  CLEAR: "Clear",
  ALTER: "Change",
  REPORT: "Report",
  ALTER_LOGIN: "Change login",
  SEND: "Send",
  GSD_FILES: "GSD Files",
  SOFTWARE_UPDATE: "Software Update",
  CURRENT_VERSION: "Current version: ",
  UPDATE: "Update",

  USER: "User",
  NEW_PASSWORD: "New password",
  REPEAT_PASSWORD: "Repeat password",
  LOGOUT: "Logout",
  TEST_NETWORK: "Test network",
  TIMEZONE: "Timezone",
  DHCP: "DHCP",
  FIXED_IP: "Fixed IP",

  INTERFACE_CONFIG: "Interface Settings",
  LOGIN: "LOGIN",

  ENTER: "Enter",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: "TS Expert detected a possible voltage level failure (Action Required).",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION: "TS Expert detected a possible voltage level failure (Urgent Action).",
  FIBER_SIGNAL_LOSS_LOG_DESCRIPTION: "TS Expert detected a possible relay failure.",
  EVENT_CHECKED_SUCCESS: "The event was cleared successfully.",

  // ---------------------------- WLAN Config ----------------------------
  WLAN_STATUS: "WLAN Adapter",
  WLAN_CONFIG: "WLAN Settings",
  CONNECTION_STATUS: "Connection status",

  WLAN_ADAPTER_ON: "On",
  WLAN_ADAPTER_OFF: "Off",

  IP_PLACEHODLER: "192.168.2.215",
  SSID: "SSID",
  SIGNAL_STRENGTH: "Signal strength",
  FREQUENCY: "Frequency",
  CHANNEL: "Channel",
  QUALITY: "Quality",

  SSID_PLACEHOLDER: "SSID",
  MAC_PLACEHOLDER: "A0:8C:FD:19:DB:02",
  SIGNAL_STRENGTH_PLACEHOLDER: "90 dBm",
  FREQUENCY_PLACEHOLDER: "2.4GHz",
  CHANNEL_PLACEHOLDER: "1",
  QUALITY_PLACEHOLDER: "Quality",

  TURNING_WLAN_OFF_WAITING: "Turning off the WLAN adapter, please wait.",
  TURNING_WLAN_ON_WAITING: "Turning on the WLAN adapter, please wait.",

  NETWORK: "Network",
  NETWORK_NAME_1: "Network name",
  SUBMASK: "Subnet mask",
  GATEWAY: "Gateway",
  PASSWORD: "Password",

  ALTER_MONITOR_WLAN_CONFIG: "Are you sure you want to change the monitor WLAN settings?",

  CONNECTED: "Connected",
  DISCONNECTED: "Disconnected",

  WLAN_STATUS_POPUP_1: "Indicates the status of the monitor WLAN adapter.",
  WLAN_STATUS_POPUP_2: "If it is turned off, it is not possible to change WLAN settings.",

  CONNECTION_STATUS_POPUP_1: "Indicates whether the monitor is connected to the configured WLAN network or not.",

  WLAN_CONFIG_POPUP_1: "It is not possible to change the settings while the WLAN adapter is turned off.",
  WLAN_CONFIG_POPUP_2: "It is highly recommended to change WLAN settings only when accessing the monitor through the wired network.",
  WLAN_CONFIG_POPUP_3: "When changing the IP / mask, if the fields appear blank after the update, this is a strong indication that:",
  WLAN_CONFIG_POPUP_4: "There is already another device on the network with the same IP;",
  WLAN_CONFIG_POPUP_5: "The subnet mask is too restrictive and does not accommodate the provided IP.",

  WLAN_ADAPTER_NOT_FOUND_1: "TS Monitor PROFIBUS could not find the WLAN adapter:\n",
  WLAN_ADAPTER_NOT_FOUND_2: "  • Check whether the adapter is disconnected or has a bad connection;\n",
  WLAN_ADAPTER_NOT_FOUND_3: "  • If the adapter is neither disconnected nor poorly connected, try replacing it;\n",
  WLAN_ADAPTER_NOT_FOUND_4: "  • If none of the above options solves the problem, contact Toledo e Souza.",

  LOADING_WAITING: "Loading information, please wait.",
  WLAN_INFO: "WLAN Information",
  MAC: "MAC",
  DNS: "DNS",

  ALTER_MONITOR_HOSTNAME_CONFIRM_1: "Are you sure you want to change the hostname?",
  ALTER_MONITOR_HOSTNAME_CONFIRM_2: "The monitor must be restarted for this.",
  HOSTNAME_POPUP_1: "A hostname must contain between 2 and 64 characters to be valid.",
  HOSTNAME_POPUP_2: "In addition, it may contain only letters, numbers, dots, and hyphens, and must start and end only with letters and numbers.",
  INVALID_HOSTNAME_1: "The hostname must contain between 2 and 64 characters.",
  INVALID_HOSTNAME_2: "The hostname must contain only letters, numbers, dots, and hyphens, and must start and end only with letters and numbers.",
  HOSTNAME_CONFIG_SUCCESS: "The hostname was configured successfully.",
  HOSTNAME_CONFIG_ERROR: "An error occurred while configuring the hostname",
  MODE: "Mode",
  HIDDEN_SSID: "Hidden SSID",
  OPTIONAL: " (Optional)",

  HOSTNAME: "Hostname",

  // ---------------------------- Edit Tags page related ----------------------------
  TAGS: "Tags",
  ADD_ALTER_TAGS: "Add/Change Tags",
  CHOOSE_DEVICE: "Choose a device",
  NEW_TAG: "New TAG",
  SAVE: "Save",
  REMOVE_ALL_TAGS: "Remove all Tags",
  REMOVE: "Remove",
  CONFIRM_REMOVE_ALL_TAGS: "Are you sure you want to remove the tags from all devices?",
  CHANGE_TAG_SUCCESS: "The tag was changed successfully.",
  CHANGE_TAG_FAILURE: "An error occurred while changing the tag",
  REMOVE_TAG_SUCCESS: "The tags were removed successfully.",
  REMOVE_TAG_FAILURE: "An error occurred while removing the tags",
  IMPORT_TAGS_SUCCESS: "The tags were imported successfully",
  IMPORT_TAGS_FAILURE: "An error occurred while importing the tags: ",
  PLEASE_SELECT_TAG_FILE: "Please select a tag file.",
  IMPORT_TAGS: "Import tags",
  EXPORT_TAGS: "Export tags",

  // ---------------------------- Edit GSD page related ----------------------------
  REMOVE_GSD_SUCCESS: "The GSD files were removed successfully",
  REMOVE_GSD_FILES: "Manage GSD files",
  SELECT_AT_LEAST_ONE_FILE_TO_DELETE: "Please select at least one file to remove",
  REMOVING_GSD_FILES: "Removing GSD files",
  FILTER_GSD_FILES: "Filter GSD files",
  SELECT_ALL: "Select all",
  REMOVER_SELECIONADOS: "Remove selected",

  // ---------------------------- Blacklist page related ----------------------------
  ADD_DEVICES_TO_BLACKLIST_FAILURE: "An error occurred while adding slaves to the blacklist.",

  REMOVE_DEVICES_FROM_BLACKLIST_FAILURE: "An error occurred while removing slaves from the blacklist.",

  REMOVE_CRITIC_DEVICES_FROM_BLACKLIST_FAILURE: "An error occurred while removing slaves from the critical slaves list.",

  BLACKLIST_FORM_INPUT_PLACEHOLDER: "Filter devices by address, tag or model",
  BLACKLIST_ADDRESS: "Address",
  BLACKLIST_TAG: "Tag",
  BLACKLIST_MODEL: "Model",
  BLACKLIST_CRITICAL_SLAVE: "Critical slave",
  UPDATE_BLACKLIST: "Update blacklist",
  UPDATING_BLACKLIST_DATA: "Updating information, please wait",

  BLACKLIST_HEADER_CELL_POPUP: "Prevents logging of a certain device in order to avoid repetitive or unwanted events.",
  BLACKLIST_HEADER_CELL_POPUP_2: "A slave in the blacklist does not change the network status in the Summary tab. Its faults, retries and diagnostics are counted.",

  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP: "Slaves that present a high number of events are automatically added to the critical slaves list. Their events stop being saved to avoid saturating the log, but their faults, retries and diagnostics are counted.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_2: "The user can remove critical slaves, but cannot add them.",
  AUTOMATIC_BLACKLIST_HEADER_CELL_POPUP_3: "If there is at least one critical slave in the list, it changes the network status to CRITICAL SLAVE in the Summary tab.",

  CONFIRM_ALTER_BLACKLIST: "Are you sure you want to make changes to the blacklist and the critical slaves list?",

  // ---------------------------- PDF Report ----------------------------
  REPORT_TYPE: "Report Type",

  PROJECT_NAME_LABEL: "Project name",
  NETWORK_LABEL: "Network name",
  LOCATION_LABEL: "Location",
  COMPANY_NAME_LABEL: "Company name",
  ACCOUNTABLE_NAME_LABEL: "Responsible person's name",
  CITY_LABEL: "City",
  TEL_LABEL: "Telephone",
  CLIENT_LOGO_LABEL: "Client logo",
  EMAIL_LABEL: "E-mail",
  EXECUTING_COMPANY_LOGO_LABEL: "Executing company logo",
  FINISHING: "Finishing...",
  SAVE_REPORT: "Save report",

  PROFIBUS: "PROFIBUS",

  REPORT_EXPORT_NAME: "TS Monitor PROFIBUS Report",
  HEADER_TEXT: "Data report - TS Monitor PROFIBUS",

  GENERATING_REPORT_WAITING: "Generating report, please wait",
  GENERATING_REPORT_SUCCESS: "Report generated successfully. To save it, click save report below.",

  CONFORMITY: "Conformity",
  DROPDOWN_PLACEHOLDER: "Choose an option",
  GENERATE_REPORT: "Generate report",

  GENERAL_REPORT: "General report – TS Monitor PROFIBUS",
  DATA_REPORT: "Data report – TS Monitor PROFIBUS",

  MONITORING_INFO: "Monitoring information",
  ETHERNET_INFO: "ETHERNET information",

  IP_DP: "- IP: ",
  MASK_DP: "- Mask: ",
  GATEWAY_DP: "- Gateway: ",

  CLIENT_INFO: "Client information",
  EXECUTING_COMPANY_INFO: "Executing company information",
  ANNOTATIONS: "Notes",
  CONCLUSION: "Conclusion",

  CONFORM_STRING: "Conforming",
  CONFORM_W_RESTRICTION_STRING: "Conforming with restrictions",
  NON_CONFORM_STRING: "Non-conforming",

  PROJECT_NAME: "- Project name:",
  NETWORK_NAME: "- Network name:",
  LOCATION: "- Location:",
  COMPANY_NAME: "- Company name:",
  ACCOUNTABLE_NAME: "- Responsible person's name:",
  COMPANY_ADDRESS: "- Address:",
  COMPANY_CITY: "- City:",
  COMPANY_TEL: "- Telephone:",

  EXECUTING_COMPANY_NAME: "- Company name:",
  EXECUTING_ACCOUNTABLE_NAME: "- Responsible person's name:",
  EXECUTING_TEL: "- Telephone:",
  EXECUTING_EMAIL: "- Email:",

  NETWORK_NAME_DP: "- Network name: ",
  TAG_NAME_DP: "- Network tag: ",
  MONITOR_VERSION_DP: "- Monitor version: ",
  MONITOR_INIT_DP: "- Monitoring start: ",
  GENERATING_TIME_DP: "- Report generation: ",
  DURATION_SINCE_MON_BEGIN: "- Monitoring duration until report generation: ",

  TS_MONITOR_VER_DP: "TS Monitor PROFIBUS - Version ",
  NETWORK_AVAILABILITY_DP: "Network availability: ",
  BAUD_RATE_DP: "Baud rate: ",
  CYCLE_TIME_DP: "Cycle time: ",
  DEVICE_DATA: "Device data",
  MASTERS_DP: "Masters: ",
  SLAVES_DP: "Slaves: ",
  ONLINE_SLAVES_DP: "Online slaves: ",
  MISSING_DP: "Missing: ",
  RETRIES_DP: "Retries: ",
  DIAGNOSTIC_DP: "Diagnostics: ",
  FAULT_DP: "Faults: ",
  WATCHDOG_DP: "Watchdog: ",
  RETRIES_LIMIT_DP: "Retry limit: ",
  HSA_DP: "HSA: ",

  SUMMARY: "Summary",
  RESUME: "Summary",
  LIVE_LIST: "Live List",
  LOG: "Log",
  MATRIX: "Matrix",
  GRAPHIC_TOPOLOGY: "Graphic topology",
  CONFIG_STRING: "Settings",

  RESUME_DOTS: ".....................................................................................................................................",
  LIVE_LIST_DOTS: ".......................................................................................................................................",
  MON_LOG_DOTS: "...............................................................................................................................................",
  DISCLAIMER_DOTS: "..........................................................................................................................",

  M_MONITORING_RESUME_PAGE_TITLE: "1. - Summary",
  M_MONITORING_LIVE_LIST_PAGE_TITLE: "2. - Live List",
  M_MONITORING_LOG_PAGE_TITLE: "3. - Log",

  OPTIC_FIBER_PAGE_TITLE: "1. - Optic Fiber",
  OPTIC_FIBER_LOG_PAGE_TITLE: "2. - Log",

  OPTIC_FIBER_DOTS: "................................................................................................................................................",
  OPTIC_FIBER_1_DOTS: "...................................................................................................",
  MONITORING_DOTS: "...................................................................................................................",

  SELECT_REPORT_TYPE: "Please select a report type",

  ADDRESS: "Address",
  MODEL: "Model",

  LAST_200_EVENTS: "Last 200 events",
  HORARY: "Time",
  DESCRIPTION: "Description",

  END_OF_REPORT: "End of report",
  DISCLAIMER: "Legal disclaimer",
  DISCLAIMER_TEXT: "The data and values presented in this report are merely auxiliary for the PROFIBUS specialist, so any indication of correction must be made by the user. For this reason, the assistance of a PROFIBUS-certified engineer or technician responsible for the analysis is recommended to validate the information provided by the product. Therefore, Toledo & Souza disclaims any liability for any direct or indirect responsibilities, losses or damages caused by software interpretations, offering no guarantee regarding the integrity, quality or adequacy of the information provided, since they depend on the technical analysis of a qualified professional. In the absence of such a professional, the user assumes the risk that the content may be inaccurate, incomplete or may not meet their needs and requirements.",

  DIAGNOSTIC_STRING: "Diagnostic",
  ONLINE_STRING: "Online",
  MISSING_PLURAL_STRING: "Missing",
  MISSING_SINGULAR_STRING: "Missing",
  CONFIG_ERROR_STRING: "Configuration error",
  PARAM_ERROR_STRING: "Parameterization error",
  FAULT_STRING: "Fault",
  BLACKLIST_STRING: "Blacklist",
  CRITIC_SLAVE_STRING: "Critical slave",
  MASTER_FAULT_STRING: "Master",
  SLAVE_MASTER_FAULT_STRING: "Master in fault",
  MPI_STRING: "MPI",
  MPI_CSV_FAULT_STRING: "MPI in fault",
  MASTER_CLASS_2: "Master",
  MASTER_OPERATE: "Master - operate",
  MASTER_SYNC: "Master - sync",
  MASTER_UNSYNC: "Master - unsync",
  MASTER_FREEZE: "Master - freeze",
  MASTER_UNFREEZE: "Master - unfreeze",
  MASTER_CLEAR: "Master - clear",
  CLASS_2: "",
  MASTER_OPERATE_CAPITAL: "Master - Operate",
  MASTER_SYNC_CAPITAL: "Master - Sync",
  MASTER_UNSYNC_CAPITAL: "Master - Unsync",
  MASTER_FREEZE_CAPITAL: "Master - Freeze",
  MASTER_UNFREEZE_CAPITAL: "Master - Unfreeze",
  MASTER_CLEAR_CAPITAL: "Master - Clear",

  PAGE: "Page",

  YEAR: " year",
  MONTH: " month",
  MONTHS: " months",
  DAY: " day",
  HOUR: " hour",
  MINUTE: " minute",
  SECOND: " second",

  // ---------------------------- OTHERS ----------------------------
  BEFORE_MONITOR_INIT_STR: "Before the last startup",
  REMOVE_DEVICE_SUCCESS: "The device will be removed within 30 seconds.",
  REMOVE_DEVICE_FAILURE: "An error occurred while removing the device: ",

  OK_STRING: "OK",
  WITH_DIAGNOSTIC_STRING: "The network has slaves in diagnostic state",
  WITH_FAILURE_STRING: "The network has slaves in fault state",
  WITH_CRITICAL_SLAVE_STRING: "The network has slaves in critical state",
  WITH_MASTER_FAULT_STRING: "The network has masters in fault state",
  UNKNOWN: "Unknown",
  LOG_WAITING: "Loading log data",
  LIVE_LIST_INPUT_TEXT_PLACEHOLDER: "Filter by address or status",
  LOG_INPUT_TEXT_PLACEHOLDER: "Filter by address, tag, model or \"Network event\"",
  OPTIC_FIBER_LOG_INPUT_TEXT_PLACEHOLDER: "Filter by event type",
  OPTIC_FIBER_INSERT_VALID_TYPE: "Please enter a valid event type.",
  SLAVE_DIAGNOSTIC: "Slave diagnostic:",
  STATUS_CHANGE: "Status change: ",
  NETWORK_EVENT: "Network event",
  MASTER_HASHTAG: "Master #",
  SLAVE_HASHTAG: "Slave #",
  CONFIG_ERROR_1: "",
  CONFIG_ERROR_2: "Configuration error",
  PARAM_ERROR_1: "",
  PARAM_ERROR_2: "Parameterization error",
  LAST_EVENT: "Last event: ",

  DIAGNOSTICS_STRING: "Diagnostics",
  RETRIES_STRING: "Retries",
  NO_FAULTS_STRING: "without faults",
  TOTAL: "total",
  RETRIES_NO_FAULT_STRING: "Retries without faults",
  FAULTS_STRING: "Faults",
  WATCHDOG_STRING: "Watchdog",
  BILLION_OF: "Billion",
  BILLIONS_OF: "Billions",
  MILLION_OF: "Million",
  MILLIONS_OF: "Millions",
  THOUSAND: "Thousand",
  LAST_EVENT_TOO_BIG_STRING: "Description too long, please check the log.",
  CRITICAL_SLAVE_EXPLANATION: "TS Monitor has an automatic function to select slaves that have an excessive number of events and informs the user that this device is critical to the PROFIBUS network.",
  DIAGNOSTICS_QUESTION_INFO: " Indicates the number of diagnostics detected on the PROFIBUS network. Diagnostics indicate abnormal device status conditions, such as short circuit, power supply issue, missing module, etc.",
  RETRIES_QUESTION_INFO: "Indicates the number of times the master had to resend a message to a certain device after receiving no response. Usually indicates problems in the physical medium.",
  FAULTS_QUESTION_INFO: "Indicates the number of times a certain PROFIBUS device stopped responding to master messages.",
  NOT_RETRIES_QUESTION_INFO: "Retries without fault help us identify network problems that have not yet caused the device to drop. It also disregards drops caused by shutdown or disconnection.",

  WATCHDOG_QUESTION_INFO_1: "The watchdog is the time the slave waits after losing communication with the master before switching its outputs to the safe condition.",
  WATCHDOG_QUESTION_INFO_2: "This parameter is sent by the master to all slaves on the network, individually, in their respective parameterization telegram.",
  WATCHDOG_QUESTION_INFO_3: "If the cycle time is close to the watchdog, the network becomes more vulnerable.",
  WATCHDOG_QUESTION_INFO: "Indicates whether the watchdog for the device is active, inactive, or not yet parameterized.",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  GRAPHIC_TOPOLOGY_INPUT_PLACEHOLDER: "Search device by address or tag",

  EDIT_TOPOLOGY_POS_STRING: "Edit",
  EDIT_EDGE_TYPE: "Edit connection type",
  SAVE_TOPOLOGY_POS_STRING: "Save",
  DELETE_TOPOLOGY_POS_STRING: "Remove",
  EXPORT_SVG: "SVG",

  EXPORT_TOPOLOGY: "Topology",
  IMPORT: "Import",
  IMPORT_TOPOLOGY: "Import Topology",
  POSITION: "Position",
  EXPORT: "Export",

  SAVE_TOPOLOGY_POS_SUCCESS_STRING: "The topology positioning was saved successfully!",
  SAVE_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while saving the topology positioning: ",

  DROP_TOPOLOGY_POS_SUCCESS_STRING: "The topology positioning was removed successfully!",
  DROP_TOPOLOGY_POS_FAILURE_STRING: "The following error occurred while removing the topology positioning: ",

  ASK_REMOVE_POSITIONING: "Are you sure you want to remove the saved positioning?",
  REMOVE_POSITIONING: "Remove positioning",

  YES: "Yes",
  NO: "No",

  ALERT_NOT_POSSIBLE_TO_EDIT: "It is not possible to edit master data",
  ALERT_NOT_POSSIBLE_TO_EDIT_SCOPE: "It is not possible to edit TS Scope data",
  ALERT_NOT_POSSIBLE_TO_DELETE: "It is not possible to remove a device from the live list",
  ALERT_CHOOSE_DEVICE_TYPE: "Please choose a device type",
  ALERT_CHOOSE_CONNECTION_TYPE: "Please select a connection type",

  ADD_DEVICE: "Add device",
  TAG_PLACEHOLDER: "TAG (optional)",

  DEVICE_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a device type",
  ADD_CONNECTION: "Add connection",
  CONNECTION_DEFAULT_DROPDOWN_PLACEHOLDER: "Choose a connection type",
  EDIT_DEVICE: "Edit device",

  CANCEL: "Cancel",
  ADD: "Add",

  MASTER_NAME: "Master",
  SLAVE_NAME: "Slave",
  SLAVE_PA_NAME: "PA Slave",
  REPEATER_NAME: "Repeater",
  HUB_NAME: "Hub",
  JB_NAME: "Junction Box",
  COUPLER_PROXY_NAME: "Coupler/Proxy",
  FIBER_LINK_NAME: "Fiber link",
  ACTIVE_TERMINATION_NAME: "Active terminator",
  UNKNOWN_NAME: "Unknown",
  TS_MONITOR_NAME: "TS Monitor",
  MPI_NAME: "MPI",
  TS_SCOPE_DP_NAME: "TS Scope DP",
  TS_SCOPE_PA_NAME: "TS Scope PA",

  LOCALE_EDIT: "Edit",
  LOCALE_DEL: "Remove selected",
  LOCALE_BACK: "Back",
  LOCALE_ADD_NODE: "Add device",
  LOCALE_ADD_EDGE: "Add connection",
  LOCALE_EDIT_NODE: "Edit device",
  LOCALE_EDIT_EDGE: "Edit connection",
  LOCALE_ADD_DESCRIPTION: "Click on a blank space to add a new device",
  LOCALE_EDGE_DESCRIPTION: "Click on a device and drag the connection to another device to connect them",
  LOCALE_EDIT_EDGE_DESCRIPTION: "Click the control points and drag them to a device to connect them",
  LOCALE_CREATE_EDGE_ERROR: "It is not possible to create a connection for a cluster",
  LOCALE_DELETE_CLUSTER_ERROR: "Clusters cannot be removed",
  LOCALE_EDIT_CLUSTER_ERROR: "Clusters cannot be edited",

  FORM_NO_DEVICE_FOUND_PREFIX: "The device with address ",
  FORM_NO_DEVICE_FOUND_SUFFIX: " was not found",

  INSERT_VALID_ADDRESS_OR_TAG: "Please enter a valid address or tag",
  INSERT_VALID_ADDRESS0_TAG_OR_MODEL: "Please enter a valid address, tag or model",

  POSITIONING_CONFLICT_1: "There is a conflict in the information of devices with addresses:",
  POSITIONING_CONFLICT_2: "\nBecause of this, their positions and connections will return to the default state.",
  POSITIONING_ANG_CONNECTIONS_RESET_SUCCESS: "Positions and connections successfully returned to the default state",
  POSITIONING_ANG_CONNECTIONS_RESET_FAILURE: "The following error occurred while returning positions and connections to the default state: ",

  TOPOLOGY_IMPORT_SUCCESS: "The topology was imported successfully!",
  ERROR_IMPORTING_GRAPHIC_TOPOLOGY: "An error occurred while importing the graphic topology: ",
  INVALID_OR_CORRUPT_FILE: "The file is invalid or corrupted.",
  PLEASE_SELECT_TOPOLOGY_FILE: "Please select a topology file.",

  COLORS_LABELS: "Color legend",
  LABEL_SLAVE_OK_MASTER_OP: ": Slave ok, and master in operate;",
  LABEL_MASTER_STOP_CLEAR: ": Master in STOP / CLEAR;",
  LABEL_SLAVE_DIAG: ": Slave in diagnostic;",
  LABEL_SLAVE_N_MASTER_FAULT: ": Slave in fault, and master in fault;",
  LABEL_SLAVE_CONFIG_ERROR: ": Slave with configuration error;",
  LABEL_SLAVE_PARAM_ERROR: ": Slave with parameterization error;",
  LABEL_SLAVE_ONLINE: ": Slave online;",
  LABEL_SLAVE_MISSING: ": Missing slave;",
  LABEL_SLAVE_MASTER_FAULT: ": Slave with master in fault;",
  LABEL_SLAVE_BLACKLIST: ": Slave in blacklist;",
  LABEL_CRITICAL_SLAVE: ": Critical slave;",
  LABEL_MPI: ": MPI;",
  LABEL_NO_STATUS: ": Device without status.",

  DEVICE_TAG_NOT_FOUND: "No device was found with TAG: ",

  INSERT_VALID_ADDRESS_1_127: "Enter a valid slave address, between 1 and 127.",
  DEVICE_WITH_ADDRESS: "The device with address ",
  WAS_SUCCESSFULLY_ADDED: " was added successfully.",
  WAS_SUCCESSFULLY_REMOVED: " was removed successfully.",
  IS_ALREADY_IN_NETWORK: " is already on the network.",
  REMOVE_DEVICE_ERROR: "The following error occurred while trying to remove the device: ",

  TS_SCOPE_NOT_FOUND: "Could not find TS Scope with IP:",
  INVALID_INSERTED_IP: "The entered IP is invalid",
  TS_SCOPE_FETCH_SUCCESS: "TS Scope fetch succeeded",

  AN_ERROR_OCURRED: "An error occurred",

  // ---------------------------- TS EXPERT CONFIG ----------------------------
  TS_EXPERT: "TS Expert",
  SETUP: "Set up",

  TS_EXPERT_CONFIGURATION: "TS Expert Settings",
  SENDING_TS_EXPERT_CONFIG_WAITING: "Updating TS Expert settings, please wait a moment.",
  TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY: "TS Expert settings were saved successfully.",
  TS_EXPERT_CONFIG_SAVE_ERROR: "An error occurred while saving TS Expert settings.",

  CONFIG_RETRIES_LIST_HEADER: "Retries without fault",
  CONFIG_RETRIES_LIST_CONTENT: "When this option is enabled, TS Expert will indicate retries that did not lead to a fault, by device. Retries without fault help us identify network problems that have not yet caused the device to drop. It also disregards drops caused by shutdown or disconnection.",

  CONFIG_DIAGNOSTIC_LIST_HEADER: "Diagnostics",
  CONFIG_DIAGNOSTIC_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all diagnostics, by device.",

  CONFIG_FAULT_LIST_HEADER: "Faults",
  CONFIG_FAULT_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all faults, by device.",

  CONFIG_FAULT_SEQUENCE_LIST_HEADER: "Fault sequence",
  CONFIG_FAULT_SEQUENCE_LIST_CONTENT: "When this option is enabled, TS Expert will record all faults that occurred in sequence in case of faults in several devices.",

  CONFIG_CONFIG_ERROR_LIST_HEADER: "Configuration error",
  CONFIG_CONFIG_ERROR_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all devices that have a configuration error.",

  CONFIG_PARAM_ERROR_LIST_HEADER: "Parameterization error",
  CONFIG_PARAM_ERROR_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all devices that have a parameterization error.",

  CONFIG_MISSING_LIST_HEADER: "Missing slave",
  CONFIG_MISSING_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all missing slaves.",

  CONFIG_ONLINE_LIST_HEADER: "Online slave",
  CONFIG_ONLINE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate all online slaves.",

  CONFIG_CRITICAL_SLAVE_LIST_HEADER: "Critical slave",
  CONFIG_CRITICAL_SLAVE_LIST_CONTENT: "When this option is enabled, TS Expert will record all critical slaves.",

  CONFIG_MASTER_FAULT_LIST_HEADER: "Master in fault",
  CONFIG_MASTER_FAULT_LIST_CONTENT: "When this option is enabled, TS Expert will indicate when TS Monitor is not receiving PROFIBUS frames.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER: "Optic fiber link – Voltage level failure (Action Required)",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_CONTENT: "When this option is enabled, TS Expert will indicate low voltage at the analog outputs that indicate the quality of the signal received by the fiber link. This value can be configured by the user on the TS Scope/Monitor PRO settings screen.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER: "Optic fiber link – Voltage level failure (Urgent Action)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_CONTENT: "When this option is enabled, TS Expert will indicate low voltage at the analog outputs that indicate the quality of the signal received by the fiber link. This value can be configured by the user on the TS Scope/Monitor PRO settings screen.",

  FIBER_SIGNAL_LOSS_LIST_HEADER: "Optic fiber link – Relay failure",
  FIBER_SIGNAL_LOSS_LIST_CONTENT: "When this option is enabled, TS Expert will show a fiber link failure indicated by relay, which must be connected to the TS Scope/Monitor PRO.",

  // ---------------------------- TS EXPERT ----------------------------
  TS_EXPERT_REPORT_EXPORT_NAME: "Action list - TS Expert - PROFIBUS",

  TS_EXPERT_POPUP_1: "This tab shows TS Expert information.",
  TS_EXPERT_POPUP_2: "This tool is an expert system developed to optimize and speed up the analysis of the main divergences detected by TS Monitor in PROFIBUS networks.",
  TS_EXPERT_POPUP_3: "In an automated way, maintenance, engineering and related teams can obtain an action list with different events, their possible causes, solution suggestions and the devices in which they were detected.",
  TS_EXPERT_POPUP_4: "Using TS Expert does not eliminate the need for human analysis, nor does it replace the human ability to correlate and interpret data.",

  DETECTED_ON: "Detected on: ",
  CHECK_YOUR_NETWORK: "Please check your network.",

  EXPORT_ACTIONS_LIST: "Export action list",
  GENERATING_ACTIONS_LIST_WAITING: "Generating action list PDF, please wait.",
  GENERATING_ACTIONS_LIST_SUCCESS: "PDF generated successfully. To save it, click save action list.",

  EVENTS_LIST: "Event list",
  ACTIONS: "Actions",

  NO_PROBLEM_DETECTED: "TS Expert did not detect any event on the network.",
  NO_EVENTS_TO_BE_ANALYZED: "There are no events to be analyzed.",

  NO_EVENT_SELECTED: "No event selected",
  CHOOSE_AN_EVENT: "Choose an event to view the suggested actions.",

  DETAILING: "Details",

  CHECKED: "Checked",
  BATCH_CHECK: "Check all",

  PROBLEM_CHECKED: "The event was checked successfully",
  PROBLEM_CHECK_ERROR: "An error occurred while checking the event.",

  LAST_UPDATED: "Last updated on: ",
  THIS_COMPUTER_TIME: " (This computer's time)",

  DEVICE: "Device",

  ALL_EVENTS_CHECKED: "All events were checked successfully.",
  _ADDRESS: "• Address: ",
  ACTIONS_LIST_EXPORT_NAME: "Action list - TS Expert - PROFIBUS.pdf",
  SAVE_ACTIONS_LIST: "Save action list",

  // ---------------------------- RETRIES (TS EXPERT) ----------------------------
  RETRIES_LIST_HEADER: "There are devices on the network that have retries without faults.",
  DEVICE_WITH_RETRIES: "Device with retries without faults.",

  RETRIES_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have retries:\n",
  S_RETRIES_INITIAL_ERROR_MSG: "Could not check the device event because it still has retries\n",

  RETRIES_SUGGESTION_1: "When a device has retries without faults, it is suggested to:",
  RETRIES_SUGGESTION_2: "Retries without faults indicate the number of times the master had to resend a message to a certain device after not receiving a response, either because the slave did not respond or because the response was corrupted (illegal or incomplete frame), due to noise, poor isolation in the slave or in the bus infrastructure. Retries without fault help us identify network problems that have not yet caused the device to drop. It also disregards drops caused by shutdown or disconnection.",
  RETRIES_SUGGESTION_3: "Check and correct the connector assembly. The TDC-1000 can help with this task;",
  RETRIES_SUGGESTION_4: "Check the PROFIBUS cable for damage, such as:",
  RETRIES_SUGGESTION_5: "Bends smaller than 10 times the conductor radius;",
  RETRIES_SUGGESTION_6: "Cuts in the cable;",
  RETRIES_SUGGESTION_7: "Twists in the cable;",
  RETRIES_SUGGESTION_8: "Crushing in the cable.",
  RETRIES_SUGGESTION_9: "These non-conformities require replacement of the cable section (it is not possible to solve the non-conformity by unbending or uncrushing the cable);",
  RETRIES_SUGGESTION_10: "Check whether there are power cables close to PROFIBUS cables. Data cables such as PROFIBUS must be kept as far away as possible or in closed and grounded cable trays/conduits, following the minimum indicated by the guidelines according to the classification of the electrical conductor, EN50174 standard;",
  RETRIES_SUGGESTION_11: "Measure leakage current on the cable with a suitable clamp meter; if the measurement is greater than 100mA, it is necessary to check equipotential bonding and the grounding system;",
  RETRIES_SUGGESTION_12: "Check signal quality with one of Toledo e Souza's devices that has an oscilloscope, which will give you tips according to the measurements taken;",
  RETRIES_SUGGESTION_13: "If none of the above solves the problem, and a particular device is showing isolated retries (only one particular slave shows retries), it is suggested to replace the slave's network interface.",
  RETRIES_SUGGESTION_14: "The only item that may yield better results with the plant running is item “d”; however, the use of Toledo e Souza equipment with an oscilloscope must be done carefully, because if the signal condition is very compromised it may bring the network down.",

  // ---------------------------- DIAGNOSTIC (TS EXPERT) ----------------------------
  DIAGNOSTIC_LIST_HEADER: "There are devices on the network that have diagnostics.",
  DEVICE_WITH_DIAGNOSTIC: "Device with diagnostics",

  DIAGNOSTIC_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have diagnostics:\n",
  S_DIAGNOSTIC_INITIAL_ERROR_MSG: "Could not check the device event because it still has diagnostics\n",

  DIAGNOSTIC_SUGGESTION_1: "When a device has diagnostics, it is suggested to:",
  DIAGNOSTIC_SUGGESTION_2: "The “Diagnostic” state is information sent by the slave to the master. It is usually not a network problem, but rather a warning from the slave that it needs maintenance or replacement. Below is the list of actions to solve the problem:",
  DIAGNOSTIC_SUGGESTION_3: "If a slave shows diagnostics, check the information sent and try to solve the problem. If you have difficulty understanding the diagnostic, contact the slave manufacturer to clarify your questions before performing any intervention;",
  DIAGNOSTIC_SUGGESTION_4: "An increasing number of diagnostics without maintenance data may be directly linked to device faults, because when the device resumes communication there is a check diagnostic that verifies whether the slave is ready for data exchange. Check whether the number of diagnostics is close to the number of faults; in this case, follow the step-by-step fault tests.",

  // ---------------------------- FAULT (TS EXPERT) ----------------------------
  FAULT_LIST_HEADER: "There are devices on the network that have faults.",
  DEVICE_WITH_FAULT: "Device with faults",

  FAULT_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have faults:\n",
  S_FAULT_INITIAL_ERROR_MSG: "Could not check the device event because it still has faults\n",

  FAULT_SUGGESTION_1: "When a device has faults, it is suggested to:",
  FAULT_SUGGESTION_2: "The “Fault” state indicates that the slave stopped communicating, that is, it stopped exchanging data with the master (dropped off the network). In this case, it is not possible to determine the cause of the fault, which may be, for example, a broken cable or lack of electrical power:",
  FAULT_SUGGESTION_3: "Check the slave power supply;",
  FAULT_SUGGESTION_4: "Check whether it is connected to the network (cable or optical fiber);",
  FAULT_SUGGESTION_5: "Check the integrity and correct assembly of the connector;",
  FAULT_SUGGESTION_6: "Check the integrity of the cable;",

  // ---------------------------- FAULT SEQUENCE (TS EXPERT) ----------------------------
  FAULT_SEQ_LIST_HEADER: "There are devices on the network that have fault sequences.",
  DEVICE_WITH_FAULT_SEQ: "Device with fault sequence",

  FAULT_SEQ_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have error sequences:\n",
  S_FAULT_SEQ_INITIAL_ERROR_MSG: "Could not check the device event because it still has error sequences\n",

  FAULTS_SEQ_SUGGESTION_1: "In the case of a sequence of device faults, it is suggested to:",
  FAULTS_SEQ_SUGGESTION_2: "Check the power supply of the slaves that stopped communicating;",
  FAULTS_SEQ_SUGGESTION_3: "Check the signal quality in the segment of the first slave that stopped communicating with one of Toledo e Souza's devices that has an oscilloscope;",
  FAULTS_SEQ_SUGGESTION_4: "Check whether they are connected to the network;",
  FAULTS_SEQ_SUGGESTION_5: "Check whether any isolating terminator was accidentally turned on;",
  FAULTS_SEQ_SUGGESTION_6: "Check the network terminators in this segment;",
  FAULTS_SEQ_SUGGESTION_7: "Check the integrity of the bus in this segment;",
  FAULTS_SEQ_SUGGESTION_8: "Check for potential faults in repeaters, hubs or fiber optic links.",

  // ---------------------------- CONFIG ERROR (TS EXPERT) ----------------------------
  CONFIG_ERROR_LIST_HEADER: "There are devices on the network with configuration error.",
  DEVICE_WITH_CONFIG_ERROR: "Device with configuration error",

  CONFIG_ERROR_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have a configuration error:\n",
  S_CONFIG_ERROR_INITIAL_ERROR_MSG: "Could not check the device event because it still has a configuration error\n",

  CONFIG_ERROR_SUGGESTION_1: "When a device has a configuration error, it is suggested to:",
  CONFIG_ERROR_SUGGESTION_2: "This occurs when a slave does not accept the configuration made in the master or DCS and does not enter data exchange. Suggestion:",
  CONFIG_ERROR_SUGGESTION_3: "Check the configuration in the master or DCS software;",

  // ---------------------------- PARAM ERROR (TS EXPERT) ----------------------------
  PARAM_ERROR_LIST_HEADER: "There are devices on the network with parameterization error.",
  DEVICE_WITH_PARAM_ERROR: "Device with parameterization error",

  PARAM_ERROR_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they still have a parameterization error:\n",
  S_PARAM_ERROR_INITIAL_ERROR_MSG: "Could not check the following device event because it still has a parameterization error\n",

  PARAM_ERROR_SUGGESTION_1: "When a device has a parameterization error, it is suggested to:",
  PARAM_ERROR_SUGGESTION_2: "This occurs when a slave does not accept the parameterization made in the master or DCS and does not enter data exchange. Parameterization is a check of the slave ID Number, that is, it may be that a different slave than the one declared in the system was installed. Suggestion:",
  PARAM_ERROR_SUGGESTION_3: "Check whether the slave declared in the master or DCS software is the same as the one installed in the field.",

  // ---------------------------- MISSING (TS EXPERT) ----------------------------
  MISSING_LIST_HEADER: "There are missing devices on the network.",
  DEVICE_MISSING: "Missing device",

  MISSING_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are still missing:\n",
  S_MISSING_INITIAL_ERROR_MSG: "Could not check the device event because it is still missing\n",

  MISSING_SUGGESTION_1: "When a device is missing, it is suggested to:",
  MISSING_SUGGESTION_2: "This occurs when the master or DCS is searching for a slave on the network but receives no response. This slave was configured in the project, but is not responding on the network or is not installed. Suggestion:",
  MISSING_SUGGESTION_3: "Check whether the slave declared in the master or DCS software is connected to the network and powered.",
  MISSING_SUGGESTION_4: "It is not recommended to leave the master or DCS searching for slaves that will not be installed.",

  // ---------------------------- ONLINE (TS EXPERT) ----------------------------
  ONLINE_LIST_HEADER: "There are online devices on the network.",
  DEVICE_ONLINE: "Online device",

  ONLINE_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are still online:\n",
  S_ONLINE_INITIAL_ERROR_MSG: "Could not check the device events because it is still online\n",

  ONLINE_SUGGESTION_1: "When a device is online, it is suggested to:",
  ONLINE_SUGGESTION_2: "This occurs when the master or DCS finds a slave on the network, but it is not configured in the system. Suggestion:",
  ONLINE_SUGGESTION_3: "Check whether the slave should be off the network or should be configured.",

  // ---------------------------- CRITICAL SLAVE (TS EXPERT) ----------------------------
  CRITICAL_SLAVE_LIST_HEADER: "There are critical slaves on the network.",
  DEVICE_IS_CRITICAL_SLAVE: "Device is a critical slave",

  CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are still critical slaves:\n",
  S_CRITICAL_SLAVE_INITIAL_ERROR_MSG: "Could not check the device event because it is still a critical slave\n",

  CRITICAL_SLAVE_SUGGESTION_1: "When there are critical slaves on the network, it is suggested to:",
  CRITICAL_SLAVE_SUGGESTION_2: "TS Monitor has an automatic function to select slaves that have an excessive number of events and informs the user that this device is critical to the PROFIBUS network. Suggestion:",
  CRITICAL_SLAVE_SUGGESTION_3: "Check the slave installation condition;",
  CRITICAL_SLAVE_SUGGESTION_4: "Check the slave power supply;",
  CRITICAL_SLAVE_SUGGESTION_5: "Check whether it is correctly connected to the network;",
  CRITICAL_SLAVE_SUGGESTION_6: "Check the integrity and correct assembly of the connector;",
  CRITICAL_SLAVE_SUGGESTION_7: "Check the integrity of the cable;",
  CRITICAL_SLAVE_SUGGESTION_8: "Check the slave signal quality with one of Toledo e Souza's devices that has an oscilloscope;",
  CRITICAL_SLAVE_SUGGESTION_9: "If the analysis with the oscilloscope-equipped device does not solve the issue, it is suggested to replace the network interface.",
  CRITICAL_SLAVE_SUGGESTION_10: "To remove the slave from this state, go to settings, then blacklist, and uncheck the checkbox.",

  // ---------------------------- MASTER FAULT (TS EXPERT) ----------------------------
  MASTER_FAULT_LIST_HEADER: "There are masters in fault on the network.",
  DEVICE_IS_MASTER_FAULT: "Device is a master in fault",

  MASTER_FAULT_INITIAL_ERROR_MSG: "Could not check the events of the following devices because they are not receiving PROFIBUS frames:\n",
  S_MASTER_FAULT_INITIAL_ERROR_MSG: "Could not check the device event because it is not receiving PROFIBUS frames\n",

  MASTER_FAULT_SUGGESTION_1: "When there are masters in fault on the network, it is suggested to:",
  MASTER_FAULT_SUGGESTION_2: "This occurs when TS Monitor PROFIBUS stops reading the network. Suggestion:",
  MASTER_FAULT_SUGGESTION_3: "Check whether there was a general network failure;",
  MASTER_FAULT_SUGGESTION_4: "Check whether TS Monitor was isolated from the network;",
  MASTER_FAULT_SUGGESTION_5: "Check whether TS Monitor is correctly connected to the PROFIBUS network.",

  VOLTAGE_: "Voltage",

  // ---------------------------- FIBER LOWER LIMIT MAINTENANCE REQUIRED ----------------------------
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_ERROR_MSG: "It was not possible to acknowledge the events because the fiber optic link still has a voltage level fault.",
  S_FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_INITIAL_ERROR_MSG: "It was not possible to acknowledge the event because the fiber optic link still has a voltage level fault.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_1: "When an optic fiber link with voltage level failure is detected, the suggestion is to visually check:",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_2: "The fiber link power supply;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_4: "Check the condition of the optical fibers.",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_SUGGESTION_5: "It is suggested to consult the fiber link manufacturer's manual to check the appropriate voltage level.",

  // ---------------------------- FIBER LOWER LIMIT URGENT MAINTENANCE ----------------------------
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_ERROR_MSG: "It was not possible to acknowledge the events because the fiber optic link still has a severe voltage level fault.",
  S_FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_INITIAL_ERROR_MSG: "It was not possible to acknowledge the event because the fiber optic link still has a severe voltage level fault.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_1: "When a fiber optic link with a severe voltage-level fault is detected, it is suggested to visually check:",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_2: "The fiber link power supply;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_4: "Check the condition of the optical fibers.",

  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_SUGGESTION_5: "It is suggested to consult the fiber link manufacturer's manual to check the appropriate voltage level.",

  // ---------------------------- FIBER SIGNAL LOSS ----------------------------
  FIBER_SIGNAL_LOSS_ERROR_MSG: "It was not possible to acknowledge the events because a fault signal is still being detected by the fiber optic link relay.",
  S_FIBER_SIGNAL_LOSS_INITIAL_ERROR_MSG: "It was not possible to acknowledge the event because a fault signal is still being detected by the fiber optic link relay.",

  FIBER_SIGNAL_LOSS_SUGGESTION_1: "When a relay fault signal is detected on the fiber optic link, it is suggested to visually check:",

  FIBER_SIGNAL_LOSS_SUGGESTION_2: "The fiber link power supply;",
  FIBER_SIGNAL_LOSS_SUGGESTION_3: "Check the fiber and copper connections;",
  FIBER_SIGNAL_LOSS_SUGGESTION_4: "Check the condition of the optical fibers.",

  // ---------------------------- EXPERT REPORT ----------------------------
  DEVICE_WITH_RETRIES_DOTS: "...............................................................................................",
  DEVICE_WITH_DIAGNOSTIC_DOTS: "...............................................................................................................",
  DEVICE_WITH_FAULT_DOTS: ".........................................................................................................................",
  DEVICE_WITH_CONFIG_ERROR_DOTS: "....................................................................................................",
  DEVICE_WITH_PARAM_ERROR_DOTS: "..............................................................................................",
  DEVICE_MISSING_DOTS: "...............................................................................................................................",
  DEVICE_ONLINE_DOTS: ".................................................................................................................................",
  DEVICE_IS_CRITICAL_SLAVE_DOTS: "................................................................................................................",
  DEVICE_IS_MASTER_FAULT_DOTS: "............................................................................................................",
  DISCLAIMER_EXPERT_DOTS_1: "..........................................................................................................................",
  DISCLAIMER_EXPERT_DOTS_2: "............................................................................................................................",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_DOTS: "...............................................................",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_DOTS: "...................................................................",
  FIBER_SIGNAL_LOSS_DOTS: "..........................................................................................................",

  TS_EXPERT_DP: "TS Expert:",
  ACTIONS_LIST: "Action list",

  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_TITLE: ". - Optic fiber link – Voltage level failure (Action Required)",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_TITLE: ". - Optic fiber link – Voltage level failure (Urgent Action)",
  FIBER_SIGNAL_LOSS_PAGE_TITLE: ". - Optic fiber link – Relay failure",
  FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with voltage level failure.",
  FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with voltage level failure.",
  FIBER_SIGNAL_LOSS_PAGE_DESCRIPTION: "TS Expert is indicating the presence of an optic fiber link with relay failure",

  // ---------------------------- OPTIC FIBER ----------------------------
  OPTIC_FIBER: "Optic Fiber",
  RELAY_STATUS: "Relay status",
  RELAY_SIGNAL: "Relay signal",
  MIN: "Minimum",
  MAX: "Maximum",
  FAULT: "Fault",
  OK: "OK",
  MIN_ANALOG_VALUE: "Minimum analog value",
  MIN_LIMIT_NOT_VALID: "The minimum analog value is not valid",
  STATUS: "Status",
  MAINTENANCE_URGENT: "Urgent Maintenance Value",
  MAINTENANCE_REQUIRED: "Required Maintenance Value",
  DIVERGENCE_MAINTENANCE_VALUE: "The required maintenance value cannot be lower than the urgent maintenance value!",
  INVALID_VALUE: "Invalid Value",
  STR_LIMIT: "Up to",
  GOOD_STRING: "Good",
  ATTENTION_STRING: "Attention",
  BAD_STRING: "Bad",
  NO_SIGNAL_STRING: "No signal",
  UNKNOWN_STRING: "Unknown",
  SIGNAL_QUALITY: "Signal quality",
  CHANNEL_1: "Channel 1",
  CHANNEL_2: "Channel 2",
  CHANNEL_3: "Channel 3",
  CHANNEL_4: "Channel 4",
  CHANNEL_5: "Channel 5",
  CHANNELS: "Channels",
  RELAY: "Relay",
  VOLTAGE: " V",
  ERROR_REASON: "\nReason: ",
  MONITORING: "Protocol",

  // ---------------------------- LANGUAGE ----------------------------
  PORTUGUESE: "Portuguese",
  ENGLISH: "English",
  SPANISH: "Spanish",
  GERMAN: "German",
  UPDATING_LANGUAGE_WAITING: "Changing language, wait a moment",
  UNABLE_TO_ALTER_LANGUAGE: "Unable to change the program's language.\n",

  UPDATES_SUCCESS: "The updates were completed successfully!",
  PS: "PS:",
  PS_1: "PS 1:",
  PS_2: "PS 2:",
  PS_3: "PS 3:",

  IP_ASSOCIATED_MONITOR: "IP of the associated monitor: ",
});

export default Constants;